export default __webpack_public_path__ + "static/media/stokerverse-rpg-core.e54a2aa2.png";